export const getters = {
  getSnackbar: (state) => state.snackbar,
};
